import DetailsFooter from './DetailsFooter';

export default DetailsFooter;
